export const hostedInIframe = window.self !== window.top ? true : false;